import cns from "classnames";
import { useEffect, useMemo, useRef, useState } from "react";
import HTMLString from "react-html-string";

import TableSizes from "@Components/TableSizes";

import styles from "./index.module.scss";

export type WysiwygProps = {
    className?: string;
    content: string;
};

const Wysiwyg: React.FC<WysiwygProps> = ({ className, content }) => {
    const components = useMemo(
        () => ({
            table: (props: any) => {
                const refComponent = useRef<HTMLTableElement>(null);

                const [cHtml, setCHtml] = useState<string | null>(null);

                useEffect(() => {
                    if (refComponent.current) {
                        setCHtml(refComponent.current?.outerHTML);
                    }
                }, []);

                return cHtml ? (
                    <TableSizes
                        className={styles.component__itemTable}
                        table={cHtml}
                    />
                ) : (
                    <table ref={refComponent} {...props} className="isHidden" />
                );
            },
        }),
        [content]
    );
    return (
        <div className={cns(className, styles.component)}>
            <HTMLString html={content} components={components} />
        </div>
    );
};

export default Wysiwyg;
